<template>
  <div class="loading"></div>
</template>

<script>
import Session from "@/util/session";
import Auth from "@/util/auth.js";
import Weixin from "@/util/weixin.js";
const baseURL = process.env.VUE_APP_API_URL || process.env.BASE_URL || '';

export default {
  mounted() {
    this.getAuthInfo();
  },
  methods: {
    /**
     * 优先使用jwt token + cookie综合检查身份信息
     * 其次获取unionid查找绑定的用户信息
     */
    getAuthInfo() {
      var me = this,
        token = Session.getToken(),
        headers = token ? {
          Authorization: token
        } : {},
        isWeixin = Weixin.isWeixin(),
        appid = me.$route.query.appid,
        redirectUrl = me.$route.query.page,
        expectedCompanyId = me.$route.query.companyId;
      me.$ajax({
        url: "/api/auth/info",
        headers,
        withCredentials: true,
      }).then(function (res) {
        if (res.success) {
          var authData = res.data;
          if (authData.unauthorized) {
            // 出现该情况是从sso登录的企业，还未开通saas应用，需要提醒用户开通
            me.redirectRegister(authData.account, authData.unauthorized);
          } else if (!authData.companyId) {
            // 出现该情况是从sso以个人身份登录，需要提醒用户切换或注册企业
            me.applyAppFromSso(authData.account);
          } else {
            Auth.set(authData);
            if (expectedCompanyId && Number(expectedCompanyId) != authData.companyId) {
              me.switchCompany(authData.account, Number(expectedCompanyId), redirectUrl);
            } else {
              me.$router.push(redirectUrl || ("/" + authData.appId.replace("-app", "")));
            }
          }
        } else {
          if (isWeixin && appid) {
            var callbackUrl = encodeURIComponent(baseURL + '/api/weixin/oauth2/callback?' + (redirectUrl ? ('url=' + redirectUrl) : '') +
              (expectedCompanyId ? ((redirectUrl ? '&' : '') + 'companyId=' + expectedCompanyId) : ''));
            // 跳转微信授权
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${callbackUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
          } else {
            me.$router.push("/login");
          }
        }
      });
    },
    /**
     * 选择需要开通saas的企业(sso中绑定的企业)
     */
    applyAppFromSso(account) {
      const me = this;
      me.getSsoCompanies(account.mobile).then(function (companies) {
        if (companies && companies.length) {
          if (companies.length == 1) {
            me.redirectRegister(account, companies[0]);
          } else {
            let items = companies.map((c) => {
              return {
                label: c.name,
                value: c,
              };
            });
            me.$weui.picker(items, {
              title: "选择公司，开通云系统",
              onConfirm: function (result) {
                me.redirectRegister(account, result[0]);
              },
            });
          }
        } else {
          me.$weui.topTips(
            "您的账号还未绑定企业，请先注册或找您的企业管理员绑定账号！",
            3000
          );
        }
      });
    },
    /**
     * 查找sso中绑定的企业
     */
    getSsoCompanies(mobile) {
      const me = this;
      return me
        .$ajax({
          url: "/api/account/account/sso_companies",
          params: {
            mobile,
          },
        })
        .then(function (res) {
          if (res.success) {
            return res.data;
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        });
    },
    /**
     * 跳转开通企业应用
     */
    redirectRegister(account, company) {
      this.$router.push({
        name: "AutoRegister",
        params: {
          signInfo: {
            mobile: account.mobile,
            userName: account.realname,
            companyName: company.name,
          },
        },
      });
    },
    switchCompany(account, companyId, redirectUrl) {
      const me = this;
      me.$loading({
        url: "/api/auth/switch/company",
        method: "POST",
        headers: {
          Authorization: Session.getToken(),
        },
        params: {
          companyId,
        },
        withCredentials: true
      }).then(function (res) {
        if (res.success) {
          let token = res.data,
            company = account.companies.find(
              (item) => item.id == companyId
            ),
            appId = company.app;
          account.defaultCompany = company;
          Auth.set({
            companyId,
            token,
            appId,
            account
          });
          me.$router.push(redirectUrl || ("/" + appId.replace("-app", "")));
        } else {
          me.$weui.topTips("切换失败：" + res.message, 3000);
        }
      });
    },
  },
};
</script>

<style scoped>
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -80px 0 0 -40px;
  width: 80px;
  height: 80px;
  border: 3px solid #d0d3d4;
  border-top-color: #626567;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>